import { useEffect, useState } from "react";
import { getLoggedinUser } from "../../helpers/api_helper";
import { Auth } from "aws-amplify";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  var token =
  userProfileSession &&
  userProfileSession["token"];
  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    var token =
      userProfileSession &&
      userProfileSession["token"];
    setUserProfile(userProfileSession ? userProfileSession : null);
    setLoading(token ? false : true);
  }, []);


  return { userProfile, loading,token };
};

const useAuth = () => {
  const [ loading, setLoading ] = useState(true);
  const [ userProfile, setUserProfile ] = useState(null);

  useEffect(() => {
    const getUser = async () => {
      const res = await Auth.currentAuthenticatedUser();
      return res;
    }

    getUser().then((user) => {
      setUserProfile(user ? user : null);
      setLoading(user ? false : true);
    }).catch(() => {
      setUserProfile(null);
      setLoading(false);
    })
  }, [])

  return { userProfile, loading };
}

export { useProfile, useAuth };